import { Consent } from '@axo/form/feature/axo-form-v2/lib/components';
import { useTranslation } from '@axo/shared/i18n';
import { ButtonSet } from '@axo/ui-core/components/Button';
import { Stack } from '@axo/ui-core/components/layout/item';
import { FormProvider, useForm } from 'react-hook-form';
import { Form } from '../../../../../components/Form';
import { Navigation } from '../../../../../components/Navigation';
import { useAuthenticationContext } from '../../../../../context/Authentication/AuthenticationContext';
import { useAxoFormContext } from '../../../../../context/AxoForm/AxoForm';
import useInitiatedTracking from '../../../../../hooks/tracking/useInitiatedTracking';
import { useMarketingConsent } from '../../../../../hooks/useMarketingConsent';
import { Step4Data } from '../../FormData.no.types';
import { BankID } from '../BankID';
import { LoanOverview } from './LoanOverview';

export const Step4 = () => {
  const { t } = useTranslation();

  const { onChange, onPrevStep, onSubmit, axoFormData } =
    useAxoFormContext<Step4Data>();

  const { isAuthenticated } = useAuthenticationContext();

  const { showMarketingConsent = true } = useMarketingConsent({
    marketingConsent: axoFormData['Ignore/MarketingConsent'],
    shouldShowMarketingConsent: axoFormData['Ignore/ShowMarketingConsent'],
  });

  const form = useForm({
    defaultValues: {
      'Debt/Personal/RefinanceAmount': 0,
      'LoanApplication/TotalRefinancingAmount': 0,
    },
    mode: 'onBlur',
  });

  const {
    formState: { isSubmitting, touchedFields },
  } = form;

  useInitiatedTracking({
    shouldTriggerOnInitiated: Object.keys(touchedFields).length > 0,
  });

  return (
    <FormProvider {...form}>
      <Form onSubmit={onSubmit} onChange={onChange}>
        <Stack>
          <BankID />

          {isAuthenticated && <LoanOverview />}

          <Consent showMarketingConsent={showMarketingConsent}>
            <Consent.TermsAndConditions />
            <Consent.Marketing />
          </Consent>

          <ButtonSet justify={'space-between'} responsive>
            <Navigation.Back onClick={onPrevStep}>{t('back')}</Navigation.Back>
            <Navigation.Continue loading={isSubmitting}>
              {t('complete')}
            </Navigation.Continue>
          </ButtonSet>
        </Stack>
      </Form>
    </FormProvider>
  );
};
